const endPoints = Object.freeze({
    AUTHORIZE: '/v3/oauth2/authorize',
    TOKEN: '/v3/oauth2/token',
    REVOKE: '/v3/oauth2/revoke'
});
export default endPoints;
